import React, { useRef, useState } from "react";
import { Button, Collapse, Form } from "react-bootstrap";
import { FiPlus, FiEdit2, FiTrash2, FiUser, FiCheck } from "react-icons/fi";
import { LuArrowRightFromLine } from "react-icons/lu";
import { FaSquarePlus } from "react-icons/fa6";
import { FaTasks } from "react-icons/fa";
import { MdAttachFile, MdFileUpload } from "react-icons/md";

const TaskThreadPanel = ({
  task,
  sectionId,
  onClose,
  onAddProjectSubtask,
  onDeleteProjectSubtask,
  onToggleSubtask,
  onEditSubtask,
  onToggleTask,
  onDeleteProjectTask,
  onDuplicateProjectTask,
}) => {
  const fileInputRef = useRef(null);
  const [newSubtaskInput, setNewSubtaskInput] = useState("");
  const [expandedSubtask, setExpandedSubtask] = useState(null);
  const [addSubtask, setAddSubtask] = useState(false);
  const [addAttachment, setAddAttachment] = useState(false);

  const handleAddSubtask = () => {
    if (newSubtaskInput.trim()) {
      onAddProjectSubtask(sectionId, task?.id);
      setNewSubtaskInput("");
    }
  };

  return (
    <aside className="task-thread-panel">
      <div className="thread-header">
        <Button
          variant="outline-success"
          size="sm"
          onClick={() => onDuplicateProjectTask(sectionId, task?.id)}
          style={{ fontSize: 12 }}
        >
          <FiCheck /> Mark as Done
        </Button>
        <LuArrowRightFromLine
          onClick={onClose}
          style={{ cursor: "pointer", fontSize: 20 }}
          className="text-muted hover-dark"
          title="Close Task"
        />
      </div>

      <div className="overflow-auto" style={{ height: "calc(100vh - 200px)" }}>
        <div className="task-thread-parent">
          <div className="d-flex gap-3">
            <div
              className="task-avatar"
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "#007bff",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {task?.title?.charAt(0).toUpperCase() || "T"}
            </div>
            <div style={{ flex: 1 }}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <strong style={{ fontSize: 14 }}>{task?.title}</strong>
                {task?.done && (
                  <span className="badge bg-success" style={{ fontSize: 10 }}>
                    Completed
                  </span>
                )}
              </div>
              <small className="text-muted">
                Task • {new Date().toLocaleDateString()}
              </small>
            </div>
          </div>
        </div>

        <div className="task-details-section">
          <div className="row">
            <div className="col-6 mb-3">
              <small className="text-muted fw-bold d-block mb-1">Status</small>
              <Form.Check
                type="checkbox"
                checked={task?.done || false}
                onChange={() => onToggleTask(sectionId, task?.id)}
                label={task?.done ? "Completed" : "In Progress"}
                style={{ fontSize: 12 }}
              />
            </div>
            <div className="col-6 mb-3">
              <small className="text-muted fw-bold d-block mb-1">
                Assigned To
              </small>
              <Button
                variant="link"
                size="sm"
                style={{ fontSize: 12, padding: 0 }}
              >
                <FiUser /> Assign
              </Button>
            </div>
          </div>
        </div>

        <div className="task-subtasks-section p-3">
          <div className="hstack gap-2 justify-content-between mb-0">
            <div className="d-flex align-items-center gap-2 mb-3">
              <FaTasks style={{ color: "#999", fontSize: 14 }} />
              <span className="fw-bold" style={{ fontSize: 13, color: "#666" }}>
                Subtasks ({(task?.subtasks || []).length})
              </span>
            </div>
            <div className="d-flex align-items-center gap-2 mb-3 CP">
              <FaSquarePlus onClick={() => setAddSubtask(!addSubtask)} style={{ fontSize: 14 }} />
            </div>
          </div>
          <Collapse in={addSubtask}>
            <div className="input-group input-group-sm mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Add a subtask?..."
                value={newSubtaskInput}
                onChange={(e) => setNewSubtaskInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleAddSubtask();
                  }
                }}
                style={{ fontSize: 12 }}
              />
              <Button variant="primary" size="sm" onClick={handleAddSubtask}>
                <FiPlus />
              </Button>
            </div>
          </Collapse>
          {task?.subtasks && task?.subtasks.length > 0 ? (
            <div className="subtasks-list">
              {task?.subtasks.map((subtask) => (
                <div
                  key={subtask?.id}
                  className="subtask-item p-2 mb-2 border rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderLeft: "3px solid #007bff",
                  }}
                  onMouseEnter={() => setExpandedSubtask(subtask?.id)}
                  onMouseLeave={() => setExpandedSubtask(null)}
                >
                  <div className="d-flex align-items-start gap-2">
                    <Form.Check
                      type="checkbox"
                      checked={subtask?.done || false}
                      onChange={() =>
                        onToggleSubtask(sectionId, task?.id, subtask?.id)
                      }
                      style={{
                        marginBottom: 0,
                        marginTop: 2,
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <span
                        style={{
                          fontSize: 12,
                          textDecoration: subtask?.done
                            ? "line-through"
                            : "none",
                          color: subtask?.done ? "#999" : "#333",
                        }}
                      >
                        {subtask?.title}
                      </span>
                    </div>
                    {expandedSubtask === subtask?.id && (
                      <div className="d-flex gap-1">
                        <Button
                          variant="light"
                          size="sm"
                          className="p-1"
                          style={{ fontSize: 11 }}
                          onClick={() => onEditSubtask(subtask)}
                          title="Edit"
                        >
                          <FiEdit2 />
                        </Button>
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            margin: "5px",
                            borderRadius:
                              "50%",
                            backgroundColor:
                              "#d946ef",
                            display: "flex",
                            alignItems:
                              "center",
                            justifyContent:
                              "center",
                            fontSize: "8px",
                            fontWeight:
                              "bold",
                            color: "white",
                          }}
                        >
                          RC
                        </div>
                        <Button
                          variant="light"
                          size="sm"
                          className="p-1"
                          style={{ fontSize: 11, color: "#f44336" }}
                          onClick={() =>
                            onDeleteProjectSubtask(sectionId, task?.id, subtask?.id)
                          }
                          title="Delete"
                        >
                          <FiTrash2 />
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted small m-0" style={{ fontSize: 12 }}>
              No subtasks yet. Add one to break down this task?.
            </p>
          )}
        </div>
        <div className="task-subtasks-section p-3">
          <div className="hstack gap-2 justify-content-between mb-0">
            <div className="d-flex align-items-center gap-2 mb-3">
              <MdAttachFile style={{ color: "#999", fontSize: 14 }} />
              <span className="fw-bold" style={{ fontSize: 13, color: "#666" }}>
                Attachment ({(task?.subtasks || []).length})
              </span>
            </div>
            <div className="d-flex align-items-center gap-2 mb-3 CP">
              <FaSquarePlus onClick={() => setAddAttachment(!addAttachment)} style={{ fontSize: 14 }} />
            </div>
          </div>
          <Collapse in={addAttachment}>
            <div className="input-group input-group-sm mb-3">
              <input
                type="file"
                className="form-control"
                multiple
                // onChange={(e) => handleFileUpload(e.target.files)}
                style={{ fontSize: 12 }}
              />
              <Button variant="primary" size="sm" onClick={() => fileInputRef.current.click()}>
                <MdFileUpload />
              </Button>
            </div>
          </Collapse>
          {task?.subtasks && task?.subtasks.length > 0 ? (
            <div className="hstack gap-2">
              {task?.subtasks
                ?.filter((subtask) => subtask?.done === undefined)
                .map((subtask) => (
                  <div
                    key={subtask?.id}
                    className="subtask-item p-2 mb-2 border rounded"
                    style={{
                      backgroundColor: "#f8f9fa",
                      borderLeft: "3px solid #007bff",
                    }}
                  >
                    <img 
                    width={100}
                    height={80}
                    src="https://img.freepik.com/premium-vector/whatsapp-app-round-icon-popular-messenger-social-media-logo_277909-873.jpg?semt=ais_incoming&w=740&q=80" />
                  </div>
                ))}
            </div>
          ) : (
            <p className="text-muted small m-0" style={{ fontSize: 12 }}>
              No attachment yet.
            </p>
          )}
        </div>
      </div>
      <div className="border-top p-2 bg-light">
        <div className="hstack gap-2 ">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => onDuplicateProjectTask(sectionId, task?.id)}
            style={{ fontSize: 12 }}
            className="w-100"
          >
            Duplicate Task
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => {
              onDeleteProjectTask(sectionId, task?.id);
              onClose();
            }}
            style={{ fontSize: 12 }}
            className="w-100"
          >
            Delete Task
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default TaskThreadPanel;
